import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class CrudDataTableService {
  constructor(private http: HttpClient) {
  }

  public getAllData(apiEndpointRoot: string): Observable<any[]> {
    return this.http.get<any[]>(apiEndpointRoot);
  }
}
